import { takeEvery, put, select } from 'redux-saga/effects';
import { consts as confirmPhoneConsts } from './confirm-mobile-phone';
import { targetUserIdSelector } from '../context/selectors';
import { consts as getUserConsts } from './get-user';

function* updateProfileWorker() {
  const id = yield select(targetUserIdSelector);
  yield put({
    type: getUserConsts.SEND,
    payload: { id },
  });
}

export function* updateProfileSaga() {
  yield takeEvery([confirmPhoneConsts.SUCCEED], updateProfileWorker);
}



// WEBPACK FOOTER //
// ./src/redux/profiles/updateProfileSaga.js